import { FC, ReactNode, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useCompanyDataState from '@/states/company-data.state';
import { CompanyDataSkeleton } from '@/pages/company-profile/company-data/CompanyDataSkeleton';

interface CompanyDataGuardProps {
  children: ReactNode;
}

export const CompanyDataGuard: FC<CompanyDataGuardProps> = ({ children }) => {
  const navigate = useNavigate();
  const { tenant_id } = useParams();
  const { hasCompanyData, isLoading } = useCompanyDataState();

  useEffect(() => {
    if (!isLoading && !hasCompanyData) {
      navigate(`/${tenant_id}/data-perusahaan`, { replace: true });
    }
  }, [hasCompanyData, isLoading, navigate, tenant_id]);

  if (isLoading) {
    return (
      <section className="w-full">
        <div className="pt-5 px-5 pb-8">
          <CompanyDataSkeleton />
        </div>
      </section>
    );
  }

  if (!hasCompanyData) {
    return null;
  }

  return <>{children}</>;
};
